import {Component, ElementRef, Inject, OnInit, ViewChild} from "@angular/core";
import {MultipleFileUploadDialogParams} from "./multiple-file-upload-dialog-params";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {forkJoin, Observable} from "rxjs";
import {MatterDocument} from "../../shared/matter-document";
import {connectApi} from "../connect-api";
import {CustomHttpParams} from "../connect-http-interceptor";
import {map} from "rxjs/internal/operators";
import {FileUploadService} from "../file-upload/file-upload.service";
import {UnityConnectTransaction} from "../model/unity-connect-transaction";
import {Referral} from "../../referral/referral";
import {MatterInfo} from "../matter-info";
import {DocSharingMessageService} from "../doc-sharing-message.service";


@Component({
    selector: 'multiple-file-upload-dialog',
    templateUrl: './multiple-file-upload-dialog.component.html'
})
export class MultipleFileUploadDialogComponent implements OnInit {

    readOnly: boolean = false;
    matterId: number;
    messageText: string;
    acceptedFileExtensions = '.bmp, .doc, .docx, .gif, .jpeg, .jpg, .pdf, .png, .txt, .tiff, .xls, .xlsx, .xml, .wpd, .tif';
    @ViewChild('multiFileUploadInput') multiFileUploadInput: ElementRef;
    uploadInProgress = false;

    selectedFiles: File[] = [];
    uploadedDocuments: MatterDocument[] = [];

    constructor(public dialogRef: MatDialogRef<MultipleFileUploadDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public params: MultipleFileUploadDialogParams,
                public fileUploadService: FileUploadService,
                public docSharingMessageService: DocSharingMessageService) {
        this.matterId = params.matterId;
        this.readOnly = params.readOnly;
        if (this.readOnly && params.message) {
            this.messageText = params.message.message;
            if (params.message) {
                this.uploadedDocuments = [];
                this.uploadedDocuments.push(... params.message.attachedDocuments);
            }
        }
    }

    ngOnInit() {
    }

    async onSend(): Promise<void> {
        this.uploadInProgress = true;
        const docUploadRequest: any[] = [];
        for (let i = 0; i < this.selectedFiles.length; i++) {
            docUploadRequest.push(this.uploadMatterInfoFile(this.selectedFiles[i], (<HTMLInputElement>document.getElementById('input-' + i)).value));
        }
        await forkJoin(docUploadRequest)
            .pipe(map(res => {
                this.uploadedDocuments.push(...<any>res);
            })).toPromise();
        console.table(this.uploadedDocuments);
        await this.docSharingMessageService.sendMessageFromUnityConnect(this.matterId, this.uploadedDocuments, this.messageText).toPromise();

        this.uploadInProgress = false;
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }


    setFileToBeUploaded() {
        const uploadFilesControl = this.multiFileUploadInput.nativeElement;
        console.log(uploadFilesControl.files);
        if (uploadFilesControl.value && uploadFilesControl.files && uploadFilesControl.files.length > 0) {
            for (const file of uploadFilesControl.files) {
                this.selectedFiles.push(file);
            }
        }
    }

    deleteDocument(file: File) {
        this.selectedFiles.splice(this.selectedFiles.indexOf(file), 1);
    }

    uploadMatterInfoFile(file: File, description: string): Observable<MatterDocument> {
        const formData = new FormData();
        formData.append('uploadedFile', file, file.name);
        if (description) {
            formData.append('description', description);
        }
        return this.fileUploadService.uploadMatterInfoFiles(formData, this.matterId.toString());
    }

}
